"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTag = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TagMixin = require("../../mixins/components/TagMixin");
var StyledTag = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledTag",
  componentId: "c11n-8-107-0__sc-1stu7t-0"
})(["", ""], _TagMixin.TagMixin);
exports.StyledTag = StyledTag;